// import logo from 'src/assets/images/web/Logo.webp';
import facebook from 'src/assets/images/user-web/Facebook.svg';
import instagram from 'src/assets/images/user-web/Instagram.svg';
import youtube from 'src/assets/images/user-web/Youtube.svg';
import { useEffect, useRef, useState } from 'react';
import * as S from 'src/pages/user-web/WebRootStyle';
import WebNotice from 'src/components/user-web/notice/WebNotice';
import { S3_IMG_BUCKET, LOGO_WIDTH } from 'src/consts/user-web.const';
import WebProgramMain from 'src/components/user-web/program-main/WebProgramMain';
import WebProgramExperience from 'src/components/user-web/program-experience/WebProgramExperience';
import WebMainPage from 'src/components/user-web/WebMainPage';
import {
  textImageModalData,
  SCROLL_TOP_BUTTON,
  SURVEY_MODAL,
  // FINAL_CANCLE,
  SPECIAL_CONCERT,
} from 'src/assets/database/webData';
import {
  FOOTER_ADDRESS,
  FOOTER_COPYRIGHT,
  FOOTER_FESTIVAL_NAME,
  FOOTER_PHONE_NUMBER,
} from 'src/assets/database/footerData';
import WebBookModal from 'src/components/user-web/modal/WebBookModal';
import WebConcertInfo from 'src/components/user-web/concert-info/WebConcertInfo';
import WebTextImageModal from 'src/components/user-web/modal/WebTextImageModal';
import WebBusTimeTableModal from 'src/components/user-web/modal/WebBusTimeTableModal';
import WebMenuBoard from 'src/components/user-web/menu-board/WebMenuBoard';
import WebVideoModal from 'src/components/user-web/modal/WebVideoModal';
import WebMenuBoardModal from 'src/components/user-web/modal/WebMenuBoardModal';
import WebEmergencyModal from 'src/components/user-web/modal/WebEmergencyModal';
import WebConcertInfoSpecial from 'src/components/user-web/concert-info/WebConcertInfoSpecial';
import WebInquiry from 'src/components/user-web/inquiry/WebInquiry';

function WebRoot({ festivalId }: { festivalId: number }) {
  const barRef = useRef<HTMLDivElement>(null);

  const [showEntireModal, setShowEntireModal] = useState(true);
  // const [showEntireModal, setShowEntireModal] = useState(false);
  // 축제 전면 취소에 따른 모달 내리기
  const [currentBtnId, setCurrentBtnId] = useState(1);
  const [currentMenu, setCurrentMenu] = useState('mainPage');
  const [scrollTop, setScrollTop] = useState(false);

  function isBetweenMarch14And16(): boolean {
    const today = new Date();
    const month = today.getMonth(); // 0부터 시작 (2 = 3월)
    const day = today.getDate();

    return month === 2 && day >= 14 && day <= 16;
  }

  const onClickBtn = (event: React.MouseEvent<HTMLButtonElement>) => {
    const { id, value } = event.currentTarget;
    setCurrentBtnId(Number(id));
    setCurrentMenu(value);
    window.scrollTo(0, 0);
  };

  useEffect(() => {
    let offsetTop = 0;
    if (barRef.current) {
      offsetTop = barRef.current.getBoundingClientRect().top;
      const handleScroll = () => {
        if (window.scrollY > offsetTop) {
          setScrollTop(true);
        } else {
          setScrollTop(false);
        }
      };
      window.addEventListener('scroll', handleScroll);
      return () => window.removeEventListener('scroll', handleScroll);
    }
    return () => {};
  }, [barRef]);

  return (
    <S.WrapperWeb>
      <S.LogoContainer>
        <S.Logo
          width={LOGO_WIDTH}
          src={`${S3_IMG_BUCKET}Logo.webp` || ''}
          alt="로고 이미지"
        />
      </S.LogoContainer>

      {/* 축제 취소후 특별공연페이지 제작을 위한 임시 숨김 */}
      {true && (
        <>
          <S.TopMovingFixedBar ref={barRef} top={scrollTop}>
            <S.BtnBox>
              <S.BarBtn
                id="1"
                onClick={onClickBtn}
                current={currentBtnId === 1}
                type="button"
                value="mainPage"
              >
                메인페이지
              </S.BarBtn>

              <S.BarBtn
                id="2"
                onClick={onClickBtn}
                current={currentBtnId === 2}
                type="button"
                value="concertInfo"
              >
                공연 정보
              </S.BarBtn>

              <S.BarBtn
                id="3"
                onClick={onClickBtn}
                current={currentBtnId === 3}
                type="button"
                value="notice"
              >
                공지사항
              </S.BarBtn>

              <S.BarBtn
                id="4"
                onClick={onClickBtn}
                current={currentBtnId === 4}
                type="button"
                value="inquiry"
              >
                문의사항
              </S.BarBtn>

              <S.BarBtn
                onClick={
                  () =>
                    window.open(
                      `${window.location.origin?.replace('://', '://m.')}/ticket`.replace(
                        'www.',
                        '',
                      ),
                    )
                  // alert(
                  //   `[입장권 예매 불가]\n입장권 예매 가능 시간이 아닙니다.\n\n<입장권 예매 시작 시간>\n2025년 4월 19일(토) 오전 10시`,
                  // )
                }
                current={false}
                type="button"
              >
                입장권 예매
              </S.BarBtn>
            </S.BtnBox>
          </S.TopMovingFixedBar>
          <S.TopMovingFixedBarBlank top={scrollTop} />
        </>
      )}

      {currentMenu === 'mainPage' && <WebMainPage />}
      {currentMenu === 'experienceProgram' && <WebProgramExperience />}
      {currentMenu === 'mainProgram' && (
        <WebProgramMain
          setCurrentBtnId={setCurrentBtnId}
          setCurrentMenu={setCurrentMenu}
        />
      )}
      {currentMenu === 'concertInfo' && <WebConcertInfo />}
      {currentMenu === 'menuBoard' && <WebMenuBoard />}
      {currentMenu === 'notice' && <WebNotice festivalId={festivalId} />}
      {currentMenu === 'specialConcert' && <WebConcertInfoSpecial />}
      {currentMenu === 'inquiry' && <WebInquiry festivalId={festivalId} />}

      <S.Footer>
        <S.IconBox>
          <img
            onClick={() => window.open()}
            src={facebook}
            alt="페이스북 이미지"
          />
          <img
            onClick={() => window.open()}
            src={instagram}
            alt="인스타그램 이미지"
          />
          <img
            onClick={() => window.open()}
            src={youtube}
            alt="유튜브 이미지"
          />
        </S.IconBox>
        <h1>{FOOTER_FESTIVAL_NAME}</h1>
        <h2>
          {FOOTER_ADDRESS} / {FOOTER_PHONE_NUMBER}
          <br />
          {FOOTER_COPYRIGHT}
        </h2>
        <h3>
          축제 디지털 가이드 제작 전문기업 <span>페스티맵</span>
        </h3>
      </S.Footer>

      {/* 팝업들 모음 (임시로 닫음) */}
      {false && showEntireModal && (
        <>
          <WebBookModal />
          {textImageModalData
            .sort((b, a) => a.id - b.id)
            ?.map(item => <WebTextImageModal key={item.id} {...item} />)}
          {isBetweenMarch14And16() && (
            <WebBusTimeTableModal
              setShowEntireModal={setShowEntireModal}
              setCurrentBtnId={setCurrentBtnId}
              setCurrentMenu={setCurrentMenu}
            />
          )}
          <WebMenuBoardModal
            setShowEntireModal={setShowEntireModal}
            setCurrentBtnId={setCurrentBtnId}
            setCurrentMenu={setCurrentMenu}
            kind="eat"
          />
          <WebMenuBoardModal
            setShowEntireModal={setShowEntireModal}
            setCurrentBtnId={setCurrentBtnId}
            setCurrentMenu={setCurrentMenu}
            kind="buy"
          />
          <WebTextImageModal
            title="축제 만족도 조사"
            summary="설문 참여하고 선물 받아가세요!"
            thumbnail={SURVEY_MODAL}
            url="https://m.site.naver.com/1Dgn9"
          />
          <WebVideoModal
            title="양방언 축전 영상"
            summary="오름향연 초대가수 축전 영상입니다."
            video="https://waba-static.s3.ap-northeast-2.amazonaws.com/firefestivaljeju/congratulatory_24ab21.mp4"
          />
          <WebVideoModal
            title="송가인 축전 영상"
            summary="개막콘서트 초대가수 축전 영상입니다."
            video="https://waba-static.s3.ap-northeast-2.amazonaws.com/firefestivaljeju/congratulatory_87ck35.mp4"
          />
          {/* <WebEmergencyModal
            title="축제 취소 안내"
            summary=""
            thumbnail={FINAL_CANCLE}
          /> */}
          <WebEmergencyModal
            title="특별공연 안내"
            summary="돌아오는 일요일 ‘희망, 잇다’ 특별공연 보러오세요!"
            thumbnail={SPECIAL_CONCERT}
          />
        </>
      )}

      <S.ScrollTopButton
        src={SCROLL_TOP_BUTTON}
        alt="위로가기 이미지"
        onClick={() => window.scrollTo(0, 0)}
      />
    </S.WrapperWeb>
  );
}

export default WebRoot;
